export default __webpack_public_path__ + "static/media/line-v-03.7ce9d81a.png";